import React, { useState } from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import { FilePond } from 'react-filepond';
import { Button } from '@mui/material';
import { EftService } from '../../../services/EftService';
import { useHistory } from 'react-router-dom';
import { EftStatementResponse } from '../../../models/EftStatement';

interface UploadStatementComponentProps {
  onClose: (show: boolean) => void;
  show: boolean;
}

const UploadStatementComponent = (props: UploadStatementComponentProps) => {
  const { show, onClose } = props;
  const [files, setFiles] = useState<any[]>([]);
  const [isUploading, toggleUploadingFlag] = useState<boolean>(false);

  const uploadStatement = (): void => {
    return
    /* 828
    if (files.length === 0) {
      return;
    }

    toggleUploadingFlag(true);

    const file: any = files[0];
    const reader = new FileReader();
    reader.onload = async () => {
      const csvString: any = reader.result;
      console.log('The file result', csvString);
      console.log('The file.filename', file);
      const response: EftStatementResponse = await EftService.uploadStatement(file.filename, csvString);
      console.log('Happy response: ', response);
      history.push(`/app/finance-area/statements/${response.eftStatement.id}`);
      // goTo(`/app/finance-area/statements/${response.eftStatement.id}`, response);
      toggleUploadingFlag(false);
    };

    reader.readAsBinaryString(file.file);

     */
  };

  const history = useHistory();

  return (
    <Dialog open={show} onClose={() => onClose(false)} maxWidth={'sm'} fullWidth={true}>
      <DialogTitle>Upload EFT Statement</DialogTitle>
      <DialogContent>
        <p>
          Please upload the CSV file for the EFT Statement. <br />
          Restrictions: file size: 300KB | file type: CSV
        </p>
        <div>
          <FilePond
            maxFiles={1}
            allowMultiple={false}
            instantUpload={false}
            oninit={() => {}}
            acceptedFileTypes={['text/csv']}
            labelFileTypeNotAllowed={'File of invalid type'}
            onupdatefiles={fileItems => {
              console.log('The file', fileItems);
              setFiles(fileItems);
            }}
          />
        </div>
        <div className={'row mt-5 align-items-center justify-content-end'}>
          <div className={'col-auto'}>
            <Button color="inherit" variant="contained" onClick={() => onClose(false)}>
              Cancel
            </Button>
          </div>
          <div className={'col-auto'}>
            <Button disabled={isUploading} onClick={() => uploadStatement()} color="primary" variant="contained">
              Upload
              {isUploading && (
                <div className={'spinner-border text-light ml-3 spinner-border-sm'}>
                  <span className={'sr-only'}>Loading</span>
                </div>
              )}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default UploadStatementComponent;
